import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Checkbox, Modal, Select, Table, Tree } from "antd";

import Http from '../../commons/utils/Http'
import Message from "../../commons/utils/message";

import { useSelector, useDispatch } from "react-redux";
import { setApplicationData } from "../../store/actions/applicationActions";
import { setRoleData, unsetRoleData } from "../../store/actions/roleActions";

import Content from "../../commons/components/content";
import Pagination from "../../commons/components/pagination";
import Input from "../../commons/components/input";
import SearchInput from "../../commons/components/searchInput";
import ButtonIcon from "../../commons/components/buttonIcon";
import Loading from "../../commons/components/loading";
import Permissions from '../../commons/utils/permissions'

import ServiceRole from '../../services/roles';
import ServiceApplication from '../../services/applications';
import ServiceModule from '../../services/modules';

export default () => {

    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);

    const applicationState = useSelector(state => state.application);
    const roleState = useSelector(state => state.role);
    const dispatch = useDispatch();

    const [loadingTable, setLoadingTable] = useState(true);
    const [loadingModules, setLoadingModules] = useState(true);
    const [loadingRoleModules, setLoadingRoleModules] = useState(true);

    const [actualPage, setActualPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [selectedRole, setSelectedRole] = useState({});
    const [applications, setApplications] = useState([]);

    const [showModalRole, setShowModalRole] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModulesModal, setShowModulesModal] = useState(false);

    const [nameError, setNameError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);

    const [treeData, setTreeData] = useState([]);
    const { TreeNode } = Tree;
    const [checkedKeys, setCheckedKeys] = useState([])

    let { Option } = Select;

    const tableColumns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Ação',
            key: 'action',
            render: (text, role) => (
                <div style={{ display: 'flex' }}>
                    {(permissions.find(_function => _function.function_id === Permissions.ASSOCIAR_MODULE)) ?
                        <ButtonIcon className="button-edit" text="Associar Módulo" type="menu-unfold" callback={() => handleModulesModal(role)} />
                        : null
                    }

                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_ROLE)) ?
                        <ButtonIcon className="button-edit" text="Editar Role" type="edit" callback={() => handleEditRole(role)} />
                        : null
                    }
                    {(permissions.find(_function => _function.function_id === Permissions.EXCLUIR_ROLE)) ?
                        <ButtonIcon className="button-red" text="Excluir Role" type="delete" callback={() => handleDeleteRole(role)} />
                        : null
                    }
                </div>
            ),
        },
    ];

    const [tableData, setTableData] = useState([])

    useEffect(() => {
        screens.map(screen => {
            if (screen.url === "/roles") {
                screen.functions.map(func => {
                    permissions.push(func)
                })
            }
        });

        getApplications()
    }, []);

    useEffect(() => {
        if (search === "") {
            getRoles()
        }
    }, [search, applicationState]);

    useEffect(() => {
        if (showModulesModal && roleState.id) {
            getRoleModules();
        }
    }, [showModulesModal]);

    function onCheckTree(checkedKeys) {
        setCheckedKeys(checkedKeys);
    };

    async function getRoles(page = 1) {
        if (applicationState.id !== "") {
            setLoadingTable(true);
            let response = await ServiceRole.getByApplication(applicationState.id, page)
            if (response) {
                formatTable(response.data.data)
                setActualPage(page);
                setTotalPages(response.data.pagination)
                setLoadingTable(false);
            }
            setShowModalRole(false)
        }
    }

    async function getRole(id) {
        setLoadingTable(true);
        let response = await ServiceRole.getId(id)
        if (response) {
            setSelectedRole(response.data.data[0]);
            setLoadingTable(false);
        }
    }

    async function getApplications(page = 1) {
        setLoadingTable(true);
        let response = await ServiceApplication.getAll(page)
        if (response) {
            const data = response.data.data;
            setApplications(data);
            setLoadingTable(false);

            const firstApplication = data[0];
            dispatch(setApplicationData(firstApplication));
        }
    }

    async function getApplication(id) {
        setLoadingTable(true);
        let response = await ServiceApplication.getId(id)
        if (response) {
            dispatch(setApplicationData(response.data.data));
            setLoadingTable(false);
        }
    }

    async function getModules() {
        setLoadingModules(true);
        let response = await ServiceModule.getModules();
        if (response) {
            let array = [];
            const data = response.data.data;
            data.forEach((item) => {
                item.index = item.id
                array.push(item)
            })
            setTreeData(array)
            setLoadingModules(false);
        }
    }

    async function getRoleModules() {
        setLoadingRoleModules(true);
        Http.get(`/modules/get-modules-by-role?id=${roleState.id}`, Http.headers)
            .then(response => {
                if (!response.data.response.error) {
                    let array = [];
                    const data = response.data.data;
                    data.forEach((item) => {
                        array.push(item.module_id)
                    })
                    setCheckedKeys(array);
                    setLoadingRoleModules(false);
                }
            }).catch(err => {
                setCheckedKeys([]);                
                setLoadingRoleModules(false);
            })
    }

    async function searchRole(search, page = 1) {
        setLoadingTable(true);

        const body = {
            "offset": page,
            "search": search,
            "application_id": applicationState.id
        };

        let response = await ServiceRole.search(body)
        if (response) {
            formatTable(response.data.data)
            setActualPage(search);
            setTotalPages(response.data.pagination)
            setLoadingTable(false);
        }
    }

    function formatTable(data) {
        let array = [];
        data.forEach((role) => {
            role.key = role.id;
            role.active = role.active === true ? "Sim" : "Não";
            array.push(role)
        })
        setTableData(array);
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchRole(search);
        }
    }

    function validateForm() {
        let valid = true;

        if (!selectedRole.name) {
            setNameError(true);
            Message.showError("Informe o nome");
            valid = false;
        }

        if (!selectedRole.description) {
            setDescriptionError(true);
            Message.showError("Informe a descrição");
            valid = false;
        }
        return valid;
    }

    function handleSaveModalRole() {
        setLoadingTable(true);
        if (validateForm()) {
            selectedRole.application_id = applicationState.id
            if (selectedRole.id) {
                update(selectedRole)
            } else {
                insert(selectedRole)
            }
        }
        setLoadingTable(false);
    }

    function handleSaveModalModules() {
        setLoadingTable(true);
        if (checkedKeys.length === 0) {
            Message.showError('Selecione um módulo')
        } else {
            const body = {};
            const bodyModules = [];

            checkedKeys.sort().forEach((item) => {
                bodyModules.push({
                    "role_id": roleState.id,
                    "module_id": item
                })
            })

            body.role_id = roleState.id
            body.modules = bodyModules;

            saveRoleModules(body)
            setShowModulesModal(false);
        }
        setLoadingTable(false);
    }

    function handleConfirmDeleteRole() {
        setLoadingTable(true);
        remove(selectedRole);
        Message.showInfo(`Role ${selectedRole.name} deletada!`)
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    function handleCancelModalRole() {
        setSelectedRole({});
        setShowModalRole(false);

        setNameError(false);
        setDescriptionError(false);
    }

    function handleCancelModalModules() {
        setSelectedRole({});
        setShowModulesModal(false);
    }

    function handleCalcelDeleteRole() {
        setSelectedRole({});
        setShowDeleteModal(false);
    }

    function handleModulesModal(role) {
        getModules();
        dispatch(setRoleData(role));
        setShowModulesModal(true);
    }

    function handleEditRole(role) {
        setLoadingTable(true);
        getRole(role.id);
        setShowModalRole(true);
        setLoadingTable(false);
    }

    function handleDeleteRole(role) {
        setLoadingTable(true);
        getRole(role.id);
        setShowDeleteModal(true);
        setLoadingTable(false);
    }

    function handleSelectedApplication(application_id) {
        getApplication(application_id);
        getRoles();
    }

    function returnConfirmAction() {
        if (search !== "") {
            searchRole(search);
        } else {
            getRoles(actualPage)
        }
    }

    function handleKeyPress(e) {
        if (e.key === "Enter") {
            handleSaveModalRole();
        }
    }

    async function insert(data) {
        let response = await ServiceRole.insert(data)
        returnConfirmAction()
    }

    async function saveRoleModules(data) {
        let response = await ServiceRole.saveRoleModules(data)
        returnConfirmAction()
    }

    async function update(data) {
        let response = await ServiceRole.update(data)
        returnConfirmAction()
    }

    async function remove(data) {
        let response = await ServiceRole.delete(data.id)
        returnConfirmAction()
    }

    const newRoleModal = () => (
        <Modal
            title="Cadastro de Roles" visible={showModalRole} onCancel={handleCancelModalRole}
            footer={[
                <button key="cancel" onClick={handleCancelModalRole} className="btn btn-light">Cancelar</button>,
                <button key="confirm" onClick={handleSaveModalRole} className="btn btn-primary">Salvar</button>
            ]}>

            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input
                            name="name" label="Nome"
                            value={selectedRole.name ? selectedRole.name : ''}
                            hasError={nameError}
                            onChange={(e) => { setSelectedRole({ ...selectedRole, name: e.target.value }); setNameError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            name="description" label="Descrição"
                            value={selectedRole.description ? selectedRole.description : ''}
                            hasError={descriptionError}
                            onChange={(e) => { setSelectedRole({ ...selectedRole, description: e.target.value }); setDescriptionError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox
                            inputId="cbAtivo"
                            onChange={(e) => { setSelectedRole({ ...selectedRole, active: e.target.checked }) }}
                            checked={selectedRole.active}
                        />
                        <label htmlFor="cb_ativo" className="p-checkbox-label" style={{ marginLeft: '5px' }}>Ativo</label>
                    </div>
                </div>
            </div>
        </Modal>
    );

    const modulesModal = () => {

        function renderModules() {
            if (loadingModules || loadingRoleModules) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                function renderTreeNodes(data) {
                    return data.map(item => {
                        return <TreeNode title={item.name} key={item.index} {...item} />;
                    });
                }

                function renderModules() {
                    return (
                        <>
                            <Tree
                                checkable
                                autoExpandParent={true}
                                onCheck={onCheckTree}
                                checkedKeys={checkedKeys}
                            >
                                {renderTreeNodes(treeData)}
                            </Tree>
                        </>
                    )
                }

                return (
                    <>
                        <div className="tree-data-container-functions">
                            {renderModules()}
                        </div>
                    </>
                );
            }
        }

        return (
            <Modal visible={showModulesModal} title={'Associação de Módulos'}
                onCancel={handleCancelModalModules} cancelText="Cancelar"
                onOk={handleSaveModalModules} okText="Salvar">

                {renderModules()}
            </Modal>
        )
    };

    const deleteRoleModal = () => (
        <Modal visible={showDeleteModal} title="Excluir role"
            onCancel={handleCalcelDeleteRole} cancelText="Cancelar" onOk={handleConfirmDeleteRole} okText="Excluir"
            okType="danger">

            <p>Tem certeza que deseja excluir a role <strong>{selectedRole.name}</strong> ?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    const renderSearchRole = () => (
        <div style={{ marginBottom: 10 }}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")} />
        </div>
    );

    const renderLoading = () => {
        if (loadingTable) {
            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Loading width={50} height={50} />
                </div>
            )
        }
    };

    const renderAddRoleButton = () => {
        if (permissions.find(_function => _function.function_id === Permissions.CADASTRAR_ROLE)) {
            function handleOpenModal() {
                setSelectedRole({})
                setShowModalRole(true)
            }

            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonIcon className="button-green" text="Adicionar Role" type="plus" label="Adicionar"
                        callback={handleOpenModal} />
                </div>
            )
        }
    };

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table pagination={false} columns={tableColumns} dataSource={tableData} />
                </div>
            </Col>
        </Fragment>
    );

    const renderSelectApplication = () => (
        <div>
            <Select
                showSearch
                style={{ width: 200 }}
                placeholder="Selecione uma aplicação"
                optionFilterProp="children"
                onChange={handleSelectedApplication}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                value={applicationState.name}>

                {applications.map(application => (
                    <Option key={application.id}>{application.name}</Option>
                ))}

            </Select>
        </div>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={6}>
                {renderSelectApplication()}
            </Col>
            <Col span={6}>
                {renderSearchRole()}
            </Col>
            <Col span={6}>
                {renderLoading()}
            </Col>
            <Col span={6}>
                {renderAddRoleButton()}
            </Col>
        </Fragment>
    );


    const renderPagination = () => (
        <Pagination totalPages={totalPages} actualPage={actualPage} callBack={(page) => getRoles(page)} />
    );

    const renderFooter = () => (
        <Fragment>
            <Col span={12}>
                {renderPagination()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Roles"]} minHeight={360}>
                {newRoleModal()}
                {deleteRoleModal()}
                {modulesModal()}

                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>

                <Row>
                    {renderTable()}
                </Row>

                <Row type="flex" align="middle">
                    {renderFooter()}
                </Row>
            </Content>
        </>
    )
}